import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Leaf component for the in-progress "@search" mark. Its only jobs are to color the typed search text
// and to expose a `data-agent-mention-search` attribute so the mention menu can locate the DOM node to
// anchor its popover to. This mirrors `InlineLinkSelection` for the inline link selection mark.
export function AgentMentionSearch({ attributes, children }) {
  return (
    <StyledSearch {...attributes} data-agent-mention-search="true">
      {children}
    </StyledSearch>
  );
}

const StyledSearch = styled.span`
  color: ${p => p.theme.colors.green400};
`;

AgentMentionSearch.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node,
};
